import React, { useEffect } from "react";

import {truncateTitle} from "../../../middleware/truncateTitle"
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { media } from "../../../server";
import {FaHandsHelping ,FaVideo ,IoBookSharp ,TbLogs ,MdKeyboardArrowDown,AiOutlineMenu, IoIosCreate, TbCategoryFilled} from "../../utils/icons"
import { ToggleDark,ToggleLanguages } from "../../utils";
import { BsChatLeft , } from "react-icons/bs";
import { useStateContext } from "../../../context/ContextProvider";
import { useTranslation } from "react-i18next";
import AdminProfil from "../utils/AdminProfil";
import { MdCreateNewFolder, MdOutlineFoodBank } from "react-icons/md";

const NavButton = ({ title, customFunc, icon, color, dotColor }) => (
  <div content={title} position="BottomCenter">
    <button
      type="button"
      onClick={() => customFunc()}
      style={{ color }}
      className="relative text-xl rounded-full p-3 hover:bg-gray-200"
    >
      <span
        style={{ background: dotColor }}
        className="absolute inline-flex rounded-full h-2 w-2 right-2 top-2"
      />
      {icon}
    </button>
  </div>
);

const NavItem = ({ title, customFunc, icon, color, dotColor }) => (
  <div content={title} position="BottomCenter">
    <button
      type="button"
      style={{ color }}
      className="relative text-xl rounded-full p-3 hover:bg-gray-200"
    >
      <span
        style={{ background: dotColor }}
        className="absolute inline-flex rounded-full h-2 w-2 right-2 top-2"
      />
      {icon}
    </button>
  </div>
);
function DashboardHeader() {
  const { user ,isAuth} = useSelector((state) => state.Users);
    const { activeMenu, setActiveMenu, handleClick, isClicked, setScreenSize, screenSize,currentColor } = useStateContext()
const {t}=useTranslation()
    useEffect(() => {
      const handleResize = () => setScreenSize(window.innerWidth);
  
      window.addEventListener('resize', handleResize);
  
      handleResize();
  
      return () => window.removeEventListener('resize', handleResize);
    }, []);
  
    useEffect(() => {
      if (screenSize <= 900) {
        setActiveMenu(false);
      } else {
        setActiveMenu(true);
      }
    }, [screenSize]);
  
    const handleActiveMenu = () => setActiveMenu(!activeMenu);
  
  return (
    <div className="fixed md:static navbar   bg-gradient-to-b from-color-5 to-color-6 dark:bg-gradient-to-b dark:from-color-9 dark:to-color-10  backdrop-blur-2xl  border border-b-1 border-t-0  border-[#ffffff1a] shadow-md   w-full ">
    <div className="flex justify-between navbar  max-h-16 p-2 md:ml-6 md:mr-6 relative">

      <div className="flex">
     
        <NavButton title="Menu" customFunc={handleActiveMenu} color={currentColor} icon={<AiOutlineMenu size={25}/>} />
      </div>
  
      <div className="flex w-full items-center">
        <div className="flex w-full justify-between items-center mr-4">
          <div className=" flex flex-row justify-center gap-5">    <ToggleDark />
          <ToggleLanguages /></div>
      
          <Link to="/DAllMealsPage" className="lg:block hidden">
           
            <NavItem title="All Meals"  color={currentColor} icon={ <MdOutlineFoodBank size={25}/>} />
          </Link>
          <Link to="/CreateMealPage" className="lg:block hidden">
          <NavItem title="Create Meal"  color={currentColor} icon={ <IoIosCreate size={25}/>} />
            
          </Link>
          <Link to="/DAllCategoriesPage" className="lg:block hidden">
          <NavItem title="Meal Categories"  color={currentColor} icon={ <TbCategoryFilled size={25}/>} />
            
          </Link>
          <Link to="/CreateCategoryPage" className="lg:block hidden">
          <NavItem title="Create Category"  color={currentColor} icon={ <MdCreateNewFolder size={25}/>} /> 
          </Link>
       
          <div content="Profile" position="BottomCenter">
          <div
            className="flex items-center gap-2 cursor-pointer p-1 hover:bg-gray-200 rounded-lg"
            onClick={() => handleClick('userProfile')}
          >
            <img
              className="rounded-full object-cover w-8 h-8"
              src={`${media}${user?.avatar}`}
              alt="user-profile"
            />
            <p>
              <span className="text-gray-400 font-kufi text-14">{t("Hi,")}</span>{' '}
              <span className="text-gray-400 font-bold font-kufi ml-1 text-md">
          {truncateTitle(user?.name, 1)}
              </span>
            </p>
            <MdKeyboardArrowDown className="text-gray-400 text-14" />
          </div>
        </div>
       
        </div>
      </div>
      {/*isClicked.chat && (<Chat />)*/}
   {isClicked.userProfile && (<AdminProfil />)}
    </div>
    </div>
  );
};

export default DashboardHeader